import React from "react"
import {
  CircularProgress as MUICircularProgres,
  CircularProgressProps as MUICircularProgressProps,
} from "@mui/material"

export type CircularProgressProps =
  | ({ new: true } & unknown)
  | ({ new?: false } & MUICircularProgressProps)

export const CircularProgress: React.FC<CircularProgressProps> = (props) =>
  props.new ? null : <MUICircularProgres {...props} />

export default CircularProgress
